import React,{useEffect,useRef,useState} from 'react';
import './Slide18Retopup.css';

export default function Slide18Retopup({slideNumber,totalSlides,pdfMode}){
  var canvasRef=useRef(null);var [phase,setPhase]=useState(pdfMode?5:0);
  var [step,setStep]=useState(0);

  useEffect(function(){var c=canvasRef.current;if(!c)return;var ctx=c.getContext('2d');var W=c.width=window.innerWidth,H=c.height=window.innerHeight,run=true;function onR(){W=c.width=window.innerWidth;H=c.height=window.innerHeight;}window.addEventListener('resize',onR);var fp=[];for(var i=0;i<30;i++)fp.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.1,vy:-0.03-Math.random()*0.12,sz:Math.random()*1.3+0.3,al:Math.random()*0.08+0.02,hue:[195,45,15][Math.floor(Math.random()*3)]});var T=0;function draw(){if(!run)return;T++;ctx.clearRect(0,0,W,H);for(var i=0;i<fp.length;i++){var p=fp[i];p.x+=p.vx;p.y+=p.vy;if(p.y<-20){p.y=H+20;p.x=Math.random()*W;}ctx.beginPath();ctx.arc(p.x,p.y,p.sz,0,6.28);ctx.fillStyle='hsla('+p.hue+',80%,70%,'+Math.max(0,p.al+Math.sin(T*0.01)*0.02)+')';ctx.fill();}requestAnimationFrame(draw);}draw();return function(){run=false;window.removeEventListener('resize',onR);};},[]);

  useEffect(function(){if(pdfMode)return;var t=[setTimeout(function(){setPhase(1);},200),setTimeout(function(){setPhase(2);},500),setTimeout(function(){setPhase(3);},900),setTimeout(function(){setPhase(4);},1400),setTimeout(function(){setPhase(5);},2000)];return function(){t.forEach(clearTimeout);};},[]);

  useEffect(function(){if(phase<5)return;var running=true;var s=0;
    function cycle(){if(!running)return;setStep(s);s=(s+1)%5;setTimeout(function(){if(running)cycle();},2500);}
    cycle();return function(){running=false;};},[phase]);

  var flowSteps=[
    {icon:'\u2713',title:'Package Active',desc:'User earning income from all streams',color:'green'},
    {icon:'\u26A0',title:'Ceiling Hit (3X)',desc:'Package reached 3X ceiling limit',color:'gold'},
    {icon:'\u2717',title:'Package Inactive',desc:'ALL income stops including board income',color:'red'},
    {icon:'\u21BB',title:'Re-topup (60%)',desc:'Pay 60% of package price to reactivate',color:'cyan'},
    {icon:'\u2713',title:'Active Again',desc:'Ceiling resets, income resumes, no new NFT',color:'green'},
  ];

  var retopups=[
    {name:'SPARK',price:10,retopup:6},
    {name:'SURGE',price:20,retopup:12},
    {name:'ASCEND',price:40,retopup:24},
    {name:'APEX',price:70,retopup:42},
    {name:'ZENITH',price:150,retopup:90},
    {name:'ORBIT',price:250,retopup:150},
    {name:'NOVA',price:450,retopup:270},
  ];

  return React.createElement('div',{className:'s18'},
    React.createElement('canvas',{ref:canvasRef,className:'s18__canvas'}),
    React.createElement('div',{className:'s18__flash'+(phase>=1?' fire':'')}),
    ['tl','tr','bl','br'].map(function(pos){return React.createElement('div',{key:pos,className:'s18__corner s18__corner--'+pos+(phase>=5?' show':'')},React.createElement('svg',{viewBox:'0 0 100 100',fill:'none'},React.createElement('path',{d:'M0 45V2H2V0H45',stroke:pos.includes('b')?'rgba(251,191,36,0.5)':'rgba(165,42,58,0.5)',strokeWidth:'1'})));}),
    React.createElement('div',{className:'s18__content'},
      React.createElement('div',{className:'s18__label'+(phase>=2?' show':'')},String(slideNumber).padStart(2,'0')+' / '+String(totalSlides).padStart(2,'0')+' \u2014 RE-TOPUP'),
      React.createElement('h1',{className:'s18__title notranslate'+(phase>=3?' show':'')},'RE-TOPUP ',React.createElement('span',{className:'s18__title-glow'},'SYSTEM')),
      React.createElement('p',{className:'s18__sub'+(phase>=4?' show':'')},'Reactivate packages at 60% cost when ceiling is hit \u2022 Keep your income flowing'),
      React.createElement('div',{className:'s18__dv'+(phase>=4?' show':'')}),

      // Flow: Active -> Ceiling Hit -> Inactive -> Retopup -> Active
      React.createElement('div',{className:'s18__flow'+(phase>=5?' show':'')},
        flowSteps.map(function(fs,i){
          var isActive=step===i;
          return React.createElement(React.Fragment,{key:i},
            React.createElement('div',{className:'s18__fs s18__fs--'+fs.color+(isActive?' s18__fs--active':'')},
              React.createElement('div',{className:'s18__fs-icon'},fs.icon),
              React.createElement('div',{className:'s18__fs-title'},fs.title),
              React.createElement('div',{className:'s18__fs-desc'},fs.desc)),
            i<4&&React.createElement('div',{className:'s18__fs-arrow'+(step>i?' s18__fs-arrow--lit':'')},'\u2192'));
        })
      ),

      // Retopup prices table
      React.createElement('div',{className:'s18__table'+(phase>=5?' show':'')},
        React.createElement('div',{className:'s18__t-title'},'RE-TOPUP PRICES (60% of Package)'),
        React.createElement('div',{className:'s18__t-grid'},
          retopups.map(function(r,i){return React.createElement('div',{key:i,className:'s18__t-item notranslate',style:{animationDelay:(i*60)+'ms'}},
            React.createElement('span',{className:'s18__t-name notranslate'},r.name),
            React.createElement('span',{className:'s18__t-price notranslate'},'$'+r.price),
            React.createElement('span',{className:'s18__t-arrow'},'\u2192'),
            React.createElement('span',{className:'s18__t-retop notranslate'},'$'+r.retopup));}))),

      // Key points
      React.createElement('div',{className:'s18__notes'+(phase>=5?' show':'')},
        React.createElement('div',{className:'s18__note'},
          React.createElement('span',{className:'s18__n-icon s18__n-icon--red'},'\u26A0'),
          React.createElement('span',null,'If ceiling hits and no re-topup: ALL income stops from that package including X6 board income')),
        React.createElement('div',{className:'s18__note'},
          React.createElement('span',{className:'s18__n-icon'},'\u2139'),
          React.createElement('span',null,'Each package is independent \u2014 other active packages continue earning normally')),
        React.createElement('div',{className:'s18__note'},
          React.createElement('span',{className:'s18__n-icon'},'\u2139'),
          React.createElement('span',null,'Re-topup does NOT give new NFTs \u2014 NFTs only on first activation')),
        React.createElement('div',{className:'s18__note'},
          React.createElement('span',{className:'s18__n-icon s18__n-icon--green'},'\u2713'),
          React.createElement('span',null,'After re-topup: ceiling resets to zero, income resumes immediately')))
    ),
    React.createElement('div',{className:'s18__bot'+(phase>=5?' show':'')},React.createElement('span',null,'bnft.live'))
  );
}
